import React, { useState, useEffect } from "react";

export default function SpeciesList({ areaSpecies, toggleSpeciesDescription, isMobile, isOpen, onToggleVisibility }) {
    const [internalIsOpen, setInternalIsOpen] = useState(false);
    
    // Use external control if provided, otherwise use internal state
    const effectiveIsOpen = isOpen !== undefined ? isOpen : internalIsOpen;
    const setEffectiveIsOpen = onToggleVisibility || setInternalIsOpen;

    // Open the list when new species data is loaded (only on desktop)
    useEffect(() => {
        if (areaSpecies.length > 0 && !isMobile) {
            setEffectiveIsOpen(true);
        }
    }, [areaSpecies, isMobile, setEffectiveIsOpen]);

    if (!effectiveIsOpen || areaSpecies.length === 0) return null;

    return (
        <div className="absolute top-6 right-6 left-6 md:left-auto md:w-80 z-10 rounded-lg shadow-2xl overflow-hidden">
            <div className="px-0">
                <div className="flex items-center justify-center py-4 bg-offwhite relative">
                    <h2 className="text-2xl font-heading font-bold text-forest text-center">
                        Artlista
                    </h2>
                    <button 
                        onClick={() => setEffectiveIsOpen(false)}
                        className="md:hidden absolute right-4 text-charcoal hover:text-forest transition-colors"
                        aria-label="Stäng artlista"
                    >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                    </button>
                </div>

                <div className="max-h-[calc(100vh-200px)] overflow-y-auto space-y-3">
                    {areaSpecies.length === 0 ? (
                        <p className="text-center text-charcoal italic py-8">
                            Ingen art tillgänglig. Välj ett naturområde för att se arter.
                        </p>
                    ) : (
                        areaSpecies.map((species) => (
                            <div key={species.id} className="bg-offwhite rounded-md shadow-md border hover:shadow-lg transition-shadow">
                                <div className="p-4">
                                    <h3 className="text-lg font-heading font-semibold text-forest mb-2">
                                        {species.name}
                                    </h3>
                                    <button
                                        onClick={() => toggleSpeciesDescription(species)}
                                        className="w-full px-4 py-2 bg-leaf text-offwhite rounded-lg hover:bg-forest transition-colors font-semibold"
                                    >
                                        Visa info
                                    </button>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
}
